export default {
  GRIMOIRE: null,
  WEBGL_VERSION: "1",
};



// WEBPACK FOOTER //
// ./src/Material/Defaults/DefaultMacro.ts